var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tg-dropdown',{attrs:{"items":_vm.dates,"trigger":"click","value":_vm.selected},on:{"on-change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }